import { render } from "./MyPage.vue?vue&type=template&id=70cc4604&scoped=true&ts=true"
import script from "./MyPage.vue?vue&type=script&lang=ts"
export * from "./MyPage.vue?vue&type=script&lang=ts"

import "./MyPage.vue?vue&type=style&index=0&id=70cc4604&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cc4604"]])

export default __exports__